import removePeriodComponent from './removePeriod.component';
import removePeriod from './removePeriod.service.js';

let removePeriodModule = angular.module('vacations-absences.removePeriod', [])

.service('RemovePeriodService',removePeriod )

.component('removePeriod', removePeriodComponent)

.name;

export default removePeriodModule;



// WEBPACK FOOTER //
// ./client/app/vacations-absences.module/components/modals/modalRemovePeriod/removePeriod/removePeriod.js